/**
 * Reviews in a row: the arrows scroll one card further, and hide at the start and the end of the row.
 * With a mouse the row can also be grabbed and dragged; touch screens swipe it natively.
 */
document.querySelectorAll('[data-reviews-scroller]').forEach((scroller) => {
  const track = scroller.querySelector('[data-reviews-scroller-track]');
  const arrows = [...scroller.querySelectorAll('[data-reviews-scroller-step]')];

  const update = () => {
    const end = track.scrollWidth - track.clientWidth - 1;
    arrows.forEach((arrow) => {
      arrow.disabled = Number(arrow.dataset.reviewsScrollerStep) < 0 ? track.scrollLeft <= 0 : track.scrollLeft >= end;
    });
  };

  arrows.forEach((arrow) => {
    arrow.addEventListener('click', () => {
      const card = track.children[0];
      const step = card.offsetWidth + parseFloat(getComputedStyle(track).columnGap);
      track.scrollBy({
        left: Number(arrow.dataset.reviewsScrollerStep) * step,
      });
    });
  });
  // Grab and drag with the mouse. Snapping waits until the row is let go.
  let start = null;
  let dragged = false;
  track.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    start = { x: event.clientX, left: track.scrollLeft };
    dragged = false;
  });
  track.addEventListener('pointermove', (event) => {
    if (!start) return;
    const distance = event.clientX - start.x;
    if (!dragged && Math.abs(distance) > 5) {
      dragged = true;
      track.setPointerCapture(event.pointerId);
      track.classList.add('is-dragging');
    }
    if (dragged) {
      track.scrollLeft = start.left - distance;
    }
  });
  const release = () => {
    if (!start) return;
    start = null;
    if (!dragged) return;
    // Lets the row snap to the nearest card from where it was dropped.
    const left = track.scrollLeft;
    track.classList.remove('is-dragging');
    track.scrollLeft = left;
  };
  track.addEventListener('pointerup', release);
  track.addEventListener('pointercancel', release);
  // A drag that ends on a link does not open it.
  track.addEventListener(
    'click',
    (event) => {
      if (dragged) {
        event.preventDefault();
        dragged = false;
      }
    },
    true,
  );
  track.addEventListener('dragstart', (event) => event.preventDefault());

  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
});
